import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SiteModel } from '../../models/site.model';
import { VenueModel } from '../../../shared/models/venue.model';
import { SbApiService } from '../../services/sb-api.service';
import { Subscription } from 'rxjs';
import { IPagination } from '../../../shared/interfaces/pagination.interface';
import { PaginatedQueryModel } from '../../../shared/models/paginatedQuery.model';
import { MessagingService } from '../../../shared/modals/messaging-modal/service/messaging.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CredentialsComponent } from '../sb-editor/modals/credentials/credentials.component';
import { SiteCopyComponent } from '../sb-editor/modals/site-copy/site-copy.component';
import { BreadcrumbsService } from 'src/app/layout/breadcrumbs/service/breadcrumbs.service';
import { PreviewComponent } from '../sb-editor/modals/preview/preview.component';
import { SblibService } from '../sb-editor/services/sblib.service';
import { SitesBuilderLibComponent } from '@3ddv/ngx-sites-builder-lib';
import { ContentDistributionVenuesApiService } from 'src/app/content-distribution/private/entities/venues/services/contentdistributionvenues.service';
import { VenuesService } from 'src/app/venues/private/services/venues.service';
import { RedirectModalComponent } from '../sb-editor/modals/redirect-modal/redirect-modal.component';

@Component({
  selector: 'app-sb-list',
  templateUrl: './sb-list.component.html',
  styleUrls: ['./sb-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SbListComponent implements OnInit, OnDestroy, DoCheck, AfterViewInit {
  public sitesList: Array<SiteModel>;
  private subscriptionHandler: Array<Subscription> = [];
  public pagination: IPagination;
  public isFiltered = false;
  public loading: boolean = false;
  private bsModalRef?: BsModalRef;

  public isSearcherOpen: boolean;
  public searchParams: { siteUrl: string };
  public tabs: {
    active: string;
  } = { active: null };

  public sblib: SitesBuilderLibComponent;
  public libVersions;

  sitebuilder: SitesBuilderLibComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private siteService: SbApiService,
    private messagingService: MessagingService,
    private modalService: BsModalService,
    private breadcrumbsService: BreadcrumbsService,
    private sblibService: SblibService,
    private cdClientService: ContentDistributionVenuesApiService,
    private venueService: VenuesService
  ) { }

  ngOnInit(): void {
    // Initialize Searcher
    this.isSearcherOpen = false;
    this.searchParams = { siteUrl: '' };
    const bc = [
      {
        label: 'Dashboard',
        url: '/dashboard',
      },
      {
        label: 'Sitesbuilder',
        url: '',
      },
    ];
    this.breadcrumbsService.set(bc);
    this.tabs.active = null;
    const o$ = this.activatedRoute.queryParams.subscribe(queryParams => {
      if (!queryParams.tab) {
        const navigationParams: NavigationExtras = {
          queryParams: {
            tab: 'production',
            page: queryParams.page ? queryParams.page : 1,
          },
          relativeTo: this.activatedRoute,
        };
        this.router.navigate(['./'], navigationParams);
      }
      this.tabs.active = queryParams.tab;
      /*       if (
        this.activatedRoute.snapshot.data.domains.length &&
        !this.activatedRoute.snapshot.data.searcher &&
        !this.activatedRoute.snapshot.data.searcher.domainsList
      ) {
        this.domains = this.activatedRoute.snapshot.data.domains;
        this.pages.total_items_in_db = this.client.meta.domains_count;
        this.venues = [];
      } */
    });
    this.subscriptionHandler.push(o$);
  }

  ngAfterViewInit(): void {
    this.siteService.getVersions().subscribe(res => {
      this.libVersions = res;
    });
    // this.siteService.getOutdatedSites().subscribe(res => {
    //   console.log(res);
    // });
    this.sblibService.sblib = this.sitebuilder;
    this.sblibService.setSblibReady();
  }

  ngDoCheck() {
    // Se utiliza ngDoCheck para que al hacer una petición detecte los cambios y inicialicen las dos variables
    this.sitesList = this.activatedRoute.snapshot.data.flow.data;
    this.pagination = this.activatedRoute.snapshot.data.flow.meta;
  }

  ngOnDestroy() {
    for (const s of this.subscriptionHandler) {
      s.unsubscribe();
    }
  }

  public enableSite(site: SiteModel): void {
    if (site.is_active) return;
    this.messagingService.warning(
      'Atención',
      `Habilitar el minisite ${site.title}, una vez habilitado se podrá acceder al contenido en la web`,
      'Aceptar',
      () => {
        this.loading = true;
        const enableSub = this.siteService.enableSite(site.id).subscribe((response: { site: SiteModel }) => {
          for (const s of this.sitesList) {
            if (s.id === response.site.id) {
              s.is_active = response.site.is_active;
              break;
            }
          }
          this.loading = false;
        });
        this.subscriptionHandler.push(enableSub);
      },
      'Cerrar'
    );
  }

  public disableSite(site: SiteModel): void {
    if (!site.is_active) return;
    this.messagingService.warning(
      'Atención',
      `Deshabilitar el minisite ${site.title}, una vez deshabilitado no se podrá acceder al contenido en la web, hasta que se vuelva a habilitar`,
      'Aceptar',
      () => {
        this.loading = true;

        const disableSub$ = this.siteService
          .disableSite(site.id)

          .subscribe((response: { site: SiteModel }) => {
            for (const s of this.sitesList) {
              if (s.id === response.site.id) {
                s.is_active = response.site.is_active;
                break;
              }
            }
            this.loading = false;
          });
        this.subscriptionHandler.push(disableSub$);
      },
      'Cerrar'
    );
  }

  public toggleSearcher() {
    this.isSearcherOpen = !this.isSearcherOpen;
  }

  public onSearch($event) {
    if ($event && $event.keyCode !== 13) {
      return;
    }
    // Api filtering
    const subscription = this.siteService
      .getSitesList(1, this.searchParams.siteUrl)
      .subscribe((sites: PaginatedQueryModel<SiteModel>) => {
        console.log('Filtered site -> ', sites);
        this.subscriptionHandler.push(subscription);
        this.isFiltered = true;
        this.sitesList.length = 0;
        sites.data.forEach(val => this.sitesList.push(Object.assign({}, val)));
        this.pagination = null;
        // Reset search
        this.isSearcherOpen = false;
      });
  }

  // public onFilter(event) {
  //   const subscription = this.siteService
  //     .getSitesList(null, event.target.value)
  //     .subscribe((sites: Array<SiteModel>) => {
  //       console.log('Filtered site -> ', sites);
  //       this.subscriptionHandler.push(subscription);
  //       this.isFiltered = true;
  //       this.sitesList.length = 0;
  //       sites.forEach((val) => this.sitesList.push(Object.assign({}, val)));
  //       this.pagination = null;
  //     });
  // }

  public onClearFilter() {
    const subscription = this.siteService.getSitesList().subscribe((query: PaginatedQueryModel<SiteModel>) => {
      this.isFiltered = false;
      this.sitesList.length = 0;
      query.data.forEach(val => this.sitesList.push(Object.assign({}, val)));
      this.pagination = query.meta;
      // Reset search
      this.searchParams = { siteUrl: '' };
      this.isSearcherOpen = false;
    });
    this.subscriptionHandler.push(subscription);
  }

  public onCredential(site: SiteModel) {
    // Open Credential modal
    const initialState: object = {
      site: site,
    };
    const modalConfig: ModalOptions = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState,
    };
    this.bsModalRef = this.modalService.show(CredentialsComponent, modalConfig);
  }

  public onDelete(site: SiteModel) {
    this.messagingService.warning(
      'Atención',
      `Vas a eliminar el minisite ${site.title}, una vez eliminado no se podrá acceder a su web`,
      'Aceptar',
      () => {
        this.loading = true;
        const subOne = this.siteService.deleteSite(site.id).subscribe(() => {
          let testing = false;
          let editor2dmaps = false;
          if (this.tabs.active === 'testing') {
            testing = true;
          }
          if (this.tabs.active === 'editor2dmaps') {
            editor2dmaps = true;
          }

          const subTwo = this.siteService
            .getSitesList(this.pagination.current_page, null, editor2dmaps, testing)
            .subscribe((query: PaginatedQueryModel<SiteModel>) => {
              this.loading = false;
              this.sitesList.length = 0;
              query.data.forEach(val => this.sitesList.push(Object.assign({}, val)));
              this.pagination = query.meta;
            });
          this.subscriptionHandler.push(subTwo);
        });
        this.subscriptionHandler.push(subOne);
      },
      'Cancelar'
    );
  }

  public redirectRefreshed(url: string) {
    window.location.href = url;
  }

  public onCopy(sitedb: SiteModel) {
    let venueToCopy: VenueModel;
    console.log(sitedb)
    this.venueService.getByKey(sitedb.venue_key).subscribe(
      {
        next: venue => {
          venueToCopy = venue.data;
          const initialState: object = {
            sitedatabase: Object.assign({}, sitedb),
            libVersion: sitedb.libversion,
            venue: venueToCopy
          };
          console.log(initialState)

          const modalConfig: ModalOptions = {
            animated: true,
            backdrop: true,
            ignoreBackdropClick: true,
            initialState,
          };
          this.bsModalRef = this.modalService.show(SiteCopyComponent, modalConfig);

          const onHide$ = this.bsModalRef.onHide.subscribe((response: ModalOptions) => {
            if (this.bsModalRef.content.closeReason == 'success') {
              this.loading = true;
              let testing = false;
              let editor2dmaps = false;
              if (this.tabs.active === 'testing') {
                testing = true;
              }
              if (this.tabs.active === 'editor2dmaps') {
                editor2dmaps = true;
              }
              const list$ = this.siteService
                .getSitesList(1, null, editor2dmaps, testing)
                .subscribe((query: PaginatedQueryModel<SiteModel>) => {
                  this.sitesList.length = 0;
                  console.log(this.sitesList);
                  query.data.forEach(val => this.sitesList.push(Object.assign({}, val)));
                  this.loading = false;
                  this.pagination = query.meta;
                });
              this.subscriptionHandler.push(list$);
            }
          });
          this.subscriptionHandler.push(onHide$);

        }
      }
    )
  }

  public toggleTabs(tab: string) {
    this.tabs.active = tab;
    /*     let defaultQueryParams = JSON.parse(
      JSON.stringify(this.activatedRoute.snapshot.queryParams)
    );
    defaultQueryParams['tab'] = tab;
    defaultQueryParams['page'] = 1;
    delete defaultQueryParams['search_domainname'];
    delete defaultQueryParams['search_venuecode']; */

    /*     this.clientSearcherService.resetSearcher();
    this.clientvenuesComp.searcher = this.clientSearcherService.searcher;
    this.clientdomainsComp.searcher = this.clientSearcherService.searcher;
*/
    const navigationParams: NavigationExtras = {
      queryParams: {
        page: '1',
        tab: tab,
      },
      relativeTo: this.activatedRoute,
    };
    this.router.navigate([], navigationParams);
  }

  public openModalPreview(site: SiteModel) {
    console.log('Site: ', site);
    // Open Credential modal
    const initialState: object = {
      site: site,
    };
    const modalConfig: ModalOptions = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState,
    };
    this.bsModalRef = this.modalService.show(PreviewComponent, modalConfig);
  }

  // Redirect Url Modal
  public onRedirect(site: SiteModel) {
    const initialState: object = {
      site: site,
    };
    const modalConfig: ModalOptions = {
      animated: true,
      backdrop: true,
      ignoreBackdropClick: true,
      initialState,
    };
    this.bsModalRef = this.modalService.show(RedirectModalComponent, modalConfig);

    const onHide$ = this.bsModalRef.onHide.subscribe((response: ModalOptions) => {
      if (this.bsModalRef.content.closeReason == 'success') {
        // Refresh site list
        const updatedSite: SiteModel = this.bsModalRef.content.updatedSite;
        let siteToUpdate = this.sitesList.find(siteItem => siteItem.id === updatedSite.id);
        if (siteToUpdate) {
          siteToUpdate = Object.assign(siteToUpdate, updatedSite);
        }
      }
    });
    this.subscriptionHandler.push(onHide$);
  }
}
